import {
  Phone,
  Mail,
  MapPin,
  Clock,
} from "lucide-react";

export default function ContactSection() {
  const contact = [
    {
      icon: Phone,
      title: "Phone",
      value: "+91 87929 24449",
      sub: "Available 24/7",
    },
    {
      icon: Mail,
      title: "Email",
      value: "contact@ebenezerstays.com",
      sub: "We'll reply within 24 hours",
    },
    {
      icon: MapPin,
      title: "Address",
      value: "#5, Ebenezer Enclave, Patel Ramaiah Garden, 1st Cross, Kothanur, Bengaluru - 560077",
      sub: "Karnataka, India",
    },
    {
      icon: Clock,
      title: "Reception",
      value: "Open Daily",
      sub: "24 Hour Check-in Assistance",
    },
  ];

  return (
    <section
      style={{
        background: "#EFE8DD",
        padding: "120px 32px",
      }}
    >
      <div
        style={{
          maxWidth: 1300,
          margin: "0 auto",
        }}
      >
        {/* Heading */}

        <div
          style={{
            textAlign: "center",
            marginBottom: 70,
          }}
        >
          <p
            style={{
              color: "#C9A66B",
              letterSpacing: ".16em",
              fontFamily: "'JetBrains Mono', monospace",
            }}
          >
            CONTACT
          </p>

          <h2
            style={{
              fontFamily: "'Fraunces', serif",
              fontSize: 52,
              color: "#222",
              margin: "18px 0",
            }}
          >
            We're here to help,
            <br />
            whenever you need us.
          </h2>

          <p
            style={{
              maxWidth: 720,
              margin: "0 auto",
              color: "#666",
              lineHeight: 1.8,
              fontSize: 18,
            }}
          >
            Have questions before your stay? Our team is happy to
            assist with bookings, long-term stays, directions and
            special requests.
          </p>
        </div>

        {/* Contact Cards */}

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
            gap: 28,
          }}
        >
          {contact.map((item) => {
            const Icon = item.icon;

            return (
              <div
                key={item.title}
                style={{
                  background: "#FFF",
                  border: "1px solid #DDD7CC",
                  padding: 40,
                  textAlign: "center",
                  transition: ".35s",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginBottom: 24,
                  }}
                >
                  <Icon
                    size={42}
                    strokeWidth={1.5}
                    color="#C9A66B"
                  />
                </div>

                <h3
                  style={{
                    fontFamily: "'Fraunces', serif",
                    color: "#222",
                    fontSize: 30,
                    marginBottom: 14,
                  }}
                >
                  {item.title}
                </h3>

                <p
                  style={{
                  color: "#444",
                  fontWeight: 600,
                  fontSize: 18,
                  marginBottom: 10,
                  textAlign: "center",
                  maxWidth: "100%",
                }}
                >
                  {item.value}
                </p>

                <p
                  style={{
                    color: "#888",
                    margin: 0,
                    fontSize: 15,
                  }}
                >
                  {item.sub}
                </p>
              </div>
            );
          })}
        </div>

        {/* CTA Buttons */}

        <div
          style={{
            marginTop: 70,
            display: "flex",
            justifyContent: "center",
            gap: 20,
            flexWrap: "wrap",
          }}
        >
          <a
            href="tel:+919876543210"
            style={{
              padding: "16px 34px",
              background: "#222",
              color: "#FFF",
              textDecoration: "none",
              fontWeight: 600,
              transition: ".3s",
            }}
          >
            Call Reception
          </a>

          <a
            href="mailto:stay@ebenezerapartments.com"
            style={{
              padding: "16px 34px",
              border: "1px solid #222",
              color: "#222",
              textDecoration: "none",
              fontWeight: 600,
              transition: ".3s",
            }}
          >
            Send an Email
          </a>
        </div>
      </div>
    </section>
  );
}